const dl = window.dataLayer || [];

export function push(data) {
  dl.push({'event': 'ts_event', eventValue: 0,  ...data});
};
